var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"page-loader"},[_c('div',{staticClass:"loader"}),_c('img',{staticClass:"loader-logo",attrs:{"src":require("../assets/logo1.png"),"alt":"ZL"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }